import {
  SESSION_STORAGE_FF_ID,
  SESSION_STORAGE_FF_LIST,
  SESSION_STORAGE_FF_POSITION,
  SESSION_STORAGE_FF_QUERY,
} from "@/constants/ui"

type FactFinderSessionAttribution = {
  productId?: string
  trackingList?: string
  searchTerm?: string
  position?: number
}

function setSessionValue(key: string, value: string | number | undefined) {
  if (typeof window === "undefined" || value === undefined || value === "") {
    return
  }

  window.sessionStorage.setItem(key, String(value))
}

function getSessionValue(key: string) {
  if (typeof window === "undefined") {
    return undefined
  }

  return window.sessionStorage.getItem(key)?.trim() || undefined
}

export function storeFactFinderSessionAttribution(attribution: FactFinderSessionAttribution) {
  setSessionValue(SESSION_STORAGE_FF_ID, attribution.productId)
  setSessionValue(SESSION_STORAGE_FF_LIST, attribution.trackingList)
  setSessionValue(SESSION_STORAGE_FF_QUERY, attribution.searchTerm)
  setSessionValue(SESSION_STORAGE_FF_POSITION, attribution.position)
}

function matchesStoredProductId(productIds?: Array<string | undefined>) {
  const validProductIds = productIds?.filter((productId): productId is string => !!productId) ?? []
  if (validProductIds.length === 0) {
    return true
  }

  const storedProductId = getSessionValue(SESSION_STORAGE_FF_ID)
  return !!storedProductId && validProductIds.includes(storedProductId)
}

export function getFactFinderSessionQuery(fallback: string, productIds?: Array<string | undefined>) {
  if (!matchesStoredProductId(productIds)) {
    return fallback
  }

  return getSessionValue(SESSION_STORAGE_FF_QUERY) || fallback
}
